
import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Box, Button, IconButton, Grid } from '@material-ui/core';
import { Link, useHistory } from "react-router-dom";
import CustomPoper from './CustomPoperUser';
import Typography from '@material-ui/core/Typography';
// import SnackBarCustom from './snackbar';
import HeaderSortable from '../common/header-sortable';
import { useTranslate } from 'react-admin';
import bin from '../assets/icons/primary-blue-bin.png';
import mobileIc from '../assets/ic_mobile_on.png';
import videoIc from '../assets/ic_video_call_on.png';
import { useLocation } from "react-router-dom";
import SnackBar from '../common/snackbar'

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        fontWeight: 'inherit',
        letterSpacing: '13px'
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default,
        maxWidth: '100px',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        fontFamily: 'UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: ' 0.13px',
        color: '#ffffff',
        '&:hover': {
            color: '#ffffff'
        },
        '&:focus': {
            color: '#ffffff'
        },
    },
    textTableName: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    textTable: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: ' 0.36px',
        color: '#6cb5b8',
        textAlign: 'center',
        padding: '8px',
    },
    textEdit: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    }, borderEdit: {
        borderRadius: '10px',
        backgroundColor: '#237fc2',
        "&:hover": {
            backgroundColor: '#65a9db'
        },
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    }
}));

const headCells = [
    { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
    { id: 'firstName', numeric: false, disablePadding: false, label: 'First Name' },
    { id: 'lastName', numeric: false, disablePadding: false, label: 'Last Name' },
    { id: 'role', numeric: false, disablePadding: false, label: 'Role' },
    { id: 'levelsCount', numeric: false, disablePadding: false, label: 'Level' },
    { id: 'mobileApp', numeric: false, disablePadding: false, label: 'App' },
    { id: 'videoCall', numeric: false, disablePadding: false, label: 'Video' },
    { id: '', numeric: false, disablePadding: false, label: '' },
];

function EnhancedTableHead(props) {
    const { classes, order, setOrder } = props;

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        className={classes.tableSortLabel}
                        key={'cell-' + headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                    >
                        {
                            (headCell.label !== "" && headCell.label !== "App" && headCell.label !== "Video") ?
                                <HeaderSortable
                                    title={headCell.label}
                                    field={headCell.id}
                                    order={order}
                                    setOrder={setOrder}
                                /> :
                                <HeaderSortable
                                    title={headCell.label}
                                    field={headCell.id}
                                    order={order}
                                    setOrder={setOrder}
                                    hiddenIconSort={true}
                                />
                        }
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function UserTable({ data, buttonHidden, total, handleDelete, error, pagination, setPagination, order, setOrder }) {
    const classes = useStyles();
    const translate = useTranslate();
    const location = useLocation();
    const [showingSnackbar, setShowingSnackbar] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const history = useHistory()

    const handleChangePage = (event, newPage) => {
        setPagination({ page: newPage, perPage: pagination.perPage });
    };

    const handleChangeRowsPerPage = (event) => {
        setPagination({ page: 0, perPage: event.target.value });
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    useEffect(() => {
        if (location.state && location.state.openEdit === true) {
            setShowingSnackbar(true);
            setTimeout(() => {
                setShowingSnackbar(false);
            }, 6000);
        }
    }, []);
    return (
        <Fragment>
            <SnackBar
                show={showingSnackbar}
                message={translate('pos.user.deleteUser')}
                onClose={() => setShowingSnackbar(false)}
            />
            <Paper className={classes.root}>

                <TableContainer className={classes.container}>
                    <Table aria-label="sticky table">
                        <EnhancedTableHead classes={classes} order={order} setOrder={setOrder} />

                        {

                            error > 0 ?
                                <TableBody>
                                    {
                                        data.map((item, index) => (
                                            buttonHidden ? <TableRow key={'table-row-' + index} hover tabIndex={-1} style={{ cursor: 'pointer' }} onClick={() => { item.id === parseInt(localStorage.getItem('id')) && history.push("/users/" + item.id) }}>
                                                <TableCell key={index + '-0'} className={classes.tableCell}><Typography className={classes.textTableName} >{item.username}</Typography></TableCell>
                                                <TableCell key={index + '-1'} className={classes.tableCell}><Typography className={classes.textTable}>{item.firstName}</Typography></TableCell>
                                                <TableCell key={index + '-2'} className={classes.tableCell}><Typography className={classes.textTable}>{item.lastName}</Typography></TableCell>
                                                <TableCell key={index + '-3'} className={classes.tableCell}><Typography className={classes.textTable}>{item.role}</Typography></TableCell>
                                                <TableCell key={index + '-4'} className={classes.tableCell} >
                                                    <Box p={0.5} mr={1} width='75%' className={classes.borderCluster}>
                                                        <Box display='flex'>
                                                            <Typography className={classes.textCluster}>
                                                                {item.levelsCount + " " + translate(item.levelsCount <= 1 ? `pos.user.cluster` : `pos.user.clusters`).toUpperCase()}
                                                            </Typography>
                                                            <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                                                                <CustomPoper open={openPoper}
                                                                    anchorEl={anchorEl}
                                                                    handleClick={handleClickOpenPoper} handleClose={handleClosePoper}
                                                                    title={translate(`pos.user.cluster`)}
                                                                    content={item.levels.join(", ")}
                                                                    icon={<b>i</b>} />
                                                            </Box>
                                                        </Box>
                                                    </Box></TableCell>
                                                <TableCell key={index + '-5'} className={classes.tableCell}>
                                                    {
                                                        item.mobileApp === 1 && <img src={mobileIc} style={{ width: 30, height: 30 }} />
                                                    }
                                                </TableCell>
                                                <TableCell key={index + '-6'} className={classes.tableCell}>
                                                    {
                                                        item.videoCall === 1 && <img src={videoIc} style={{ width: 30, height: 30 }} />
                                                    }
                                                </TableCell>
                                                <TableCell key={index + '-7'} className={classes.tableCell}>
                                                    {
                                                        (!buttonHidden || (parseInt(localStorage.getItem('id')) == item.id)) && (
                                                            <Grid container >
                                                                <Grid hidden={buttonHidden ? (parseInt(localStorage.getItem('id')) === item.id ? false : true) : false}>
                                                                    <Button
                                                                        disabled={item.role === "Sysadmin" ? true : false}
                                                                        variant="contained"
                                                                        // className={classes.borderEdit}
                                                                        color='primary'
                                                                        size='small'
                                                                    >
                                                                        <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.user.edituser`)} </Typography>
                                                                    </Button>
                                                                </Grid>
                                                                <Grid display="flex" hidden={(item.role === "Sysadmin" ? true : false || (parseInt(localStorage.getItem('id')) === item.id)) ? true : false}>
                                                                    <IconButton
                                                                        style={{ marginLeft: '1em', padding: '10px' }}
                                                                        className={classes.borderDelete}
                                                                        size='small'
                                                                        onClick={(e) => {
                                                                            handleDelete(item)
                                                                            e.stopPropagation()
                                                                        }}
                                                                    >
                                                                        <img src={bin} style={{ width: "15px" }} />
                                                                    </IconButton>
                                                                </Grid>

                                                            </Grid>

                                                        )
                                                    }
                                                </TableCell>
                                            </TableRow> :
                                                <TableRow key={'table-row-' + index} hover tabIndex={-1} style={{ cursor: 'pointer' }} onClick={() => { item.role !== 'Sysadmin' && history.push("/users/" + item.id) }}>
                                                    <TableCell key={index + '-0'} className={classes.tableCell}><Typography className={classes.textTableName} >{item.username}</Typography></TableCell>
                                                    <TableCell key={index + '-1'} className={classes.tableCell}><Typography className={classes.textTable}>{item.firstName}</Typography></TableCell>
                                                    <TableCell key={index + '-2'} className={classes.tableCell}><Typography className={classes.textTable}>{item.lastName}</Typography></TableCell>
                                                    <TableCell key={index + '-3'} className={classes.tableCell}><Typography className={classes.textTable}>{item.role}</Typography></TableCell>
                                                    <TableCell key={index + '-4'} className={classes.tableCell}>
                                                        <Box p={0.5} mr={1} width='75%' display='flex' className={classes.borderCluster}>
                                                            <Typography className={classes.textCluster}>
                                                                {item.levelsCount + " " + translate(item.levelsCount <= 1 ? `pos.user.cluster` : `pos.user.clusters`).toUpperCase()}
                                                            </Typography>
                                                            <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                                                                <CustomPoper open={openPoper}
                                                                    anchorEl={anchorEl}
                                                                    handleClick={handleClickOpenPoper} handleClose={handleClosePoper}
                                                                    title={translate(`pos.user.cluster`)}
                                                                    content={item.levels.join(", ")}
                                                                    icon={<b>i</b>} />
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell key={index + '-5'} className={classes.tableCell}>
                                                        {
                                                            item.mobileApp === 1 && <img src={mobileIc} style={{ width: 30, height: 30 }} />
                                                        }
                                                    </TableCell>
                                                    <TableCell key={index + '-6'} className={classes.tableCell}>
                                                        {
                                                            item.videoCall === 1 && <img src={videoIc} style={{ width: 30, height: 30 }} />
                                                        }
                                                    </TableCell>
                                                    <TableCell key={index + '-7'} className={classes.tableCell}>
                                                        {
                                                            (!buttonHidden || (parseInt(localStorage.getItem('id')) === item.id)) && (
                                                                <Grid container >
                                                                    <Grid hidden={(item.role === "Sysadmin" ? true : false)}>
                                                                        <Button
                                                                            disabled={item.role === "Sysadmin" ? true : false}
                                                                            variant="contained"
                                                                            // className={classes.borderEdit}
                                                                            color='primary'
                                                                            size='small'
                                                                        // component={Link}
                                                                        // to={{
                                                                        //     pathname: "/users/" + item.id
                                                                        // }}
                                                                        >
                                                                            <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.user.edituser`)} </Typography>
                                                                        </Button>
                                                                    </Grid>
                                                                    <Grid display="flex" hidden={(item.role === "Sysadmin" ? true : false || (parseInt(localStorage.getItem('id')) === item.id)) ? true : false}>
                                                                        <IconButton
                                                                            style={{ marginLeft: '1em', padding: '10px' }}
                                                                            className={classes.borderDelete}
                                                                            size='small'
                                                                            onClick={(e) => {
                                                                                handleDelete(item)
                                                                                e.stopPropagation()
                                                                            }}
                                                                        >
                                                                            {/* <Delete color='primary' /> */}
                                                                            <img src={bin} style={{ width: "15px" }} />
                                                                        </IconButton>
                                                                    </Grid>

                                                                </Grid>

                                                            )
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                        ))
                                    }

                                </TableBody> :
                                <TableBody>
                                    <TableRow>
                                        <TableCell className={classes.tableCell}></TableCell>
                                        <TableCell className={classes.tableCell}></TableCell>
                                        <TableCell className={classes.tableCell}> <Typography className={classes.textTable}>{translate(`pos.user.error.datanotfound`)} </Typography></TableCell>
                                        <TableCell className={classes.tableCell}></TableCell>
                                        <TableCell className={classes.tableCell}></TableCell>
                                        <TableCell className={classes.tableCell}></TableCell>
                                    </TableRow>
                                </TableBody>
                        }
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={total}
                    rowsPerPage={pagination.perPage}
                    page={pagination.page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </Fragment>

    );
}

export default UserTable;
